import React from 'react'
import cs from 'classnames'
import iphoneTop from '../../../assets/Iphone3.png'
import iphoneBottom from '../../../assets/Iphone4.png'
import intlMessagesApp from 'src/modules/App/translations'

import SvgIcon from 'src/components/SvgIcon'

import commonStyles from '../../common.module.less'

import styles from './styles.module.less'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'

import toReactComponent from 'svgr.macro'

const TapIconUp = toReactComponent('../../../assets/TapIconUp3x.svg')
const TapIconLeft = toReactComponent('../../../assets/TapIconLeft3x.svg')

export default injectIntl(({ intl }) => {
  return (
    <section className={cs(commonStyles.container)}>
      <section className={commonStyles.top}>
        <img
          src={iphoneTop}
          className={styles.bgStepTop}
          alt={intl.formatMessage(intlMessagesApp.altScreenshot)}
        />
        <img
          src={iphoneBottom}
          className={styles.bgStepBottom}
          alt={intl.formatMessage(intlMessagesApp.altScreenshot)}
        />
        <TapIconUp className={styles.iconUpStep} />
        <div className={styles.leftStepText}>iPhone X</div>
        <TapIconLeft className={styles.iconLeftStep} />
      </section>
      <section className={commonStyles.bottom}>
        <div className={commonStyles.content}>
          <header>
            <SvgIcon
              className={commonStyles.iconFabStep}
              size='xlg'
              type='UnlockedIcon'
              style={{ margin: '5px auto' }}
            />
            <h2>
              <FormattedMessage id='app.lock.screen.header.privacy' defaultMessage='Privacy' />
            </h2>
            <p>
              <FormattedMessage
                id='app.lock.screen.header.privacy.description.ios.end'
                defaultMessage='End a Guided Access session'
              />
            </p>
          </header>
          <div className={commonStyles.scrollable}>
            <p>
              <FormattedHTMLMessage
                id='app.lock.ios.screen4.p1'
                defaultMessage='<b>Triple-click the Home button or side button (Iphone X)</b>, enter your Guided Access passcode, then tap End. Or if you turned on Touch ID or Face ID for Guided Access, double-click the Home or side button.'
              />
            </p>
          </div>
        </div>
      </section>
    </section>
  )
})
